import axios from 'axios';
import { type ApiResponse } from 'tendril-v1/src/types/ApiResponse';
import routes from 'tendril-v1/src/constants/routes';
import { type CSVContact } from './entities/contact.entity';
import { type Filters } from '@domain/interfaces/Contacts/filter.interfaces.ts';

const getContactsByCallSessionIds = async (
  callSessionIdsParam: string[],
  filters: Filters = {
    flagged: false,
    no_answer: false,
    voicemail: false,
    transfer_error: false,
    cut_off: false,
  },
): Promise<ApiResponse<CSVContact[]>> => {
  try {
    const callSession = await axios.post<CSVContact[]>(`${routes.get.contacts.byCallSessionIds}`, {
      callSessionIds: callSessionIdsParam,
      ...filters,
    });

    return { data: callSession.data };
  } catch {
    return { error: { message: 'Error getting contacts by call session id' } };
  }
};

export default getContactsByCallSessionIds;
